import { createApp } from 'vue/dist/vue.esm-bundler'
import { createI18n } from '@shared/i18n'
import locales from '../i18n/locales.json'

import App from '@components/SideBar.vue'

const i18n = createI18n(locales)

document.addEventListener('DOMContentLoaded', () => {
  createApp({ components: { App } }).use(i18n).mount('aside.side_menu')
})
